import { extendObservable, runInAction } from 'mobx';

import { Logger } from '../helpers/Logger';
import { Storage } from '../helpers/Storage';
import { MenusController } from '../networking/controllers/MenusController';

const MENU_STORAGE_KEY = 'menustore-menus';
const MAX_RETRIES = 3;

class MenuStoreClass {
  constructor() {
    extendObservable(this, {
      menus: null,
    });
    this.retries = 0;
    this.fetchMenusFromStorage();
  }

  fetchMenusFromStorage() {
    const menus = Storage.get(MENU_STORAGE_KEY);
    if (menus) {
      Logger.log('Menus found on storage');
      runInAction(() => {
        this.menus = menus;
      });
    }
    this.fetchMenus();
  }

  async fetchMenus() {
    if (this.retries > MAX_RETRIES) {
      Logger.warn('Menu fetching exceeded retry limit.');
      return;
    }
    try {
      const menus = await MenusController.all();
      menus.sort((a, b) => a.index - b.index);
      Storage.set(MENU_STORAGE_KEY, menus);
      this.retries = 0;
      runInAction(() => {
        this.menus = menus;
      });
      Logger.log('Menus loaded correctly');
    } catch (error) {
      Logger.warn(`Failed to fetch menus, retried ${this.retries} times, error was: ${error.message}`);
      // Retry
      this.retries += 1;
      this.fetchMenus();
    }
  }
}

const MenuStore = new MenuStoreClass();

export { MenuStore };



// WEBPACK FOOTER //
// ./src/stores/MenuStore.js